// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./product-list/product-details/styles.scss
// module id = 946
// module chunks = 0